import { render, staticRenderFns } from "./FormOffer.vue?vue&type=template&id=7b771590&"
import script from "./FormOffer.vue?vue&type=script&lang=js&"
export * from "./FormOffer.vue?vue&type=script&lang=js&"
import style0 from "./FormOffer.vue?vue&type=style&index=0&id=7b771590&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b771590')) {
      api.createRecord('7b771590', component.options)
    } else {
      api.reload('7b771590', component.options)
    }
    module.hot.accept("./FormOffer.vue?vue&type=template&id=7b771590&", function () {
      api.rerender('7b771590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Offers/FormOffer.vue"
export default component.exports